import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for FITTING_INSTANCES
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'fittingInstance',
  plural: 'fittingInstances',
  state: 'fittingInstances',
  collection: 'fittingInstancesAttributes'
};
